class DsdTheme {
  constructor() {
    this.cartDrawer = document.querySelector('[data-cart-drawer]');
    this.cartLines = document.querySelector('[data-cart-lines]');
    this.cartCount = document.querySelector('[data-cart-count]');
    this.cartTotal = document.querySelector('[data-cart-total]');
    this.bindMenus();
    this.bindCart();
    this.bindProductForms();
    this.bindVariantSelectors();
  }

  bindMenus() {
    const menu = document.querySelector('[data-mobile-menu]');
    document.querySelector('[data-mobile-open]')?.addEventListener('click', () => menu?.removeAttribute('hidden'));
    document.querySelector('[data-mobile-close]')?.addEventListener('click', () => menu?.setAttribute('hidden', ''));
  }

  bindCart() {
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', () => this.openCart()));
    document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', () => this.closeCart()));
  }

  bindProductForms() {
    document.querySelectorAll('form[data-product-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        button?.setAttribute('disabled', 'disabled');
        try {
          const body = new FormData(form);
          const response = await fetch('/cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Cart add failed');
          await this.refreshCart();
          this.openCart();
        } catch (error) {
          window.location.href = '/cart';
        } finally {
          button?.removeAttribute('disabled');
        }
      });
    });
  }

  bindVariantSelectors() {
    document.querySelectorAll('[data-product-section]').forEach((section) => {
      const json = section.querySelector('[data-product-json]');
      if (!json) return;
      const product = JSON.parse(json.textContent || '{}');
      const selects = section.querySelectorAll('[data-option-position]');
      const idInput = section.querySelector('[data-variant-id]');
      const price = section.querySelector('[data-product-price]');
      const button = section.querySelector('[data-add-button]');
      const update = () => {
        const selected = Array.from(selects).map((select) => select.value);
        const variant = product.variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        idInput.value = variant.id;
        price.textContent = this.formatMoney(Number(variant.price) / 100, window.Shopify?.currency?.active || window.DsdThemeCurrency || 'ZAR');
        button.disabled = !variant.available;
        button.querySelector('span').textContent = variant.available ? 'Add to cart' : 'Sold out';
      };
      selects.forEach((select) => select.addEventListener('change', update));
    });
  }

  async refreshCart() {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    if (this.cartCount) this.cartCount.textContent = cart.item_count;
    if (this.cartTotal) this.cartTotal.textContent = this.formatMoney(cart.total_price / 100, cart.currency);
    if (!this.cartLines) return;
    if (cart.item_count === 0) {
      this.cartLines.innerHTML = '<div class="cart-empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg><p>Your cart is empty.</p></div>';
      return;
    }
    this.cartLines.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-line-key="${this.escape(item.key)}">
        <a class="cart-line-image" href="${item.url}">${item.image ? `<img src="${item.image}" alt="${this.escape(item.product_title)}">` : ''}</a>
        <div class="cart-line-copy">
          <h3>${this.escape(item.product_title)}</h3>
          <p>${this.escape(item.variant_title || '')}</p>
          <strong>${this.formatMoney(item.final_line_price / 100, cart.currency)}</strong>
          <div class="quantity-row">
            <button type="button" data-cart-change="${this.escape(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change="${this.escape(item.key)}" data-quantity="${item.quantity + 1}">+</button>
          </div>
        </div>
      </div>`).join('');
    this.cartLines.querySelectorAll('[data-cart-change]').forEach((button) => {
      button.addEventListener('click', async () => {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.cartChange, quantity: Number(button.dataset.quantity) }) });
        await this.refreshCart();
      });
    });
  }

  openCart() { this.refreshCart(); this.cartDrawer?.removeAttribute('hidden'); }
  closeCart() { this.cartDrawer?.setAttribute('hidden', ''); }
  formatMoney(amount, currency) { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(amount)); }
  escape(value) { return String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char])); }
}

document.addEventListener('DOMContentLoaded', () => new DsdTheme());
